<template>
  <div class="">
    <div class="footer">
      <div class="container">
        <div class="footer-nav">
          <ul class="clearfix">
            <li>
              <h3>公司简介</h3>
              <a href="/about">关于MT</a>
              <a href="/about">联系我们</a>
            </li>

            <li>
              <h3>服务内容</h3>
              <a href="/service">服务项目</a></li>

            <li>
              <h3>行业资讯</h3>
              <a href="/industry">付费资讯</a></li>

            <li>
              <h3>账号中心</h3>
              <a href="/register">账号注册</a> <a
                href="/login">会员登录</a></li>
            <li>
              <h3>微信公众号</h3>
              <img src="https://api.pwmqr.com/qrcode/create/?url=http://www.zxtechgroup.com/" class="code"></li>
            <li class="contact">
              <img src="../assets/img.png" class="img">
              <div>
                <h3>联系电话</h3>
                <p class="tel"><a href=""  style="color: #bababa; text-decoration: none; ">18513110521</a></p>
                <p>周一至周日 09:00-18:00</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="copy">
        <div>
          2021-2024©&nbsp;北京执享信息科技有限公司版权所有 &nbsp;联系电话：18513110521
        </div>
        <span >
          地址：北京市朝阳区姚家园路105号1号楼4层503室1号&nbsp;ICP备案：<a href="https://beian.miit.gov.cn/" target="_blank" style="color: #bababa; text-decoration: none; ">京ICP备2022033460号-1</a>
        </span>
      </div>
    </div>


  </div>
</template>


<script setup>

</script>


<style scoped>

.clearfix {
  display: flex;
  justify-content: space-between;
}
.disFlex{
  display: flex;
  align-items: center;
  text-align: center;
}
.contact {
  display: flex;
  justify-content: space-between;
}

.container {
  width: 100%;
  margin: 0 auto;
  position: relative;
}

ul {
  color: white;
  list-style: none;
}

.img {
  width: 20%;
  height: 20%;
  margin: 20px 20px 0 20px
}

li > a {
  color: #bababa;
}

li > a {
  display: block;
  margin-top: 10px;
  text-decoration: none;
}

.code {
  width: 80%;
}

.copy{
  padding: 30px 0;
  color: #bababa;
  text-align: center;
  border-top: solid 1px #191d2e
}

li {
  float: left;
  width: 15%;
  padding-right: 15px;
  line-height: 26px
}

.footer-nav {
  padding: 0 20% 5% 20%;
}

.footer {
  padding-top: 70px;
  background: #111523
}
</style>